import React, { useContext, useEffect, useState } from "react"

import Paper from "@material-ui/core/Paper"
import Container from "@material-ui/core/Container"
import Grid from "@material-ui/core/Grid"
import { makeStyles } from "@material-ui/core/styles"
import Typography from "@material-ui/core/Typography";

import useTickets from "../../hooks/useTickets"
import api from "../../services/api";
import toastError from "../../errors/toastError";

import { AuthContext } from "../../context/Auth/AuthContext";

import { i18n } from "../../translate/i18n";

import Chart from "./Chart"

const useStyles = makeStyles(theme => ({
	container: {
		paddingTop: theme.spacing(4),
		paddingBottom: theme.spacing(4),
	},
	fixedHeightPaper: {
		padding: theme.spacing(2),
		display: "flex",
		overflow: "auto",
		flexDirection: "column",
		height: 240,
	},
	customFixedHeightPaper: {
		padding: theme.spacing(2),
		display: "flex",
		overflow: "auto",
		flexDirection: "column",
		height: 120,
	},
	customFixedHeightPaperLg: {
		padding: theme.spacing(2),
		display: "flex",
		overflow: "auto",
		flexDirection: "column",
		height: "100%",
	},
	attentionSummary: {
		marginTop: theme.spacing(1),
	},
	attentionSummaryLine: {
		fontSize: 13,
		lineHeight: 1.6,
	},
	needsAttentionLine: {
		color: theme.palette.error.main,
	},
	attendedLine: {
		color: theme.palette.success.main,
	},
	postponedLine: {
		color: theme.palette.text.secondary,
		paddingLeft: theme.spacing(2),
	},
	inAttendancePaper: {
		padding: theme.spacing(2),
		display: "flex",
		overflow: "hidden",
		flexDirection: "column",
		minHeight: 190,
	},
}))

const Dashboard = () => {
	const classes = useStyles()

	const { user } = useContext(AuthContext);
	var userQueueIds = [];

	if (user.queues && user.queues.length > 0) {
		userQueueIds = user.queues.map(q => q.id);
	}

	const GetTickets = (status, showAll, withUnreadMessages) => {

		const { count } = useTickets({
			status: status,
			showAll: showAll,
			withUnreadMessages: withUnreadMessages,
			queueIds: JSON.stringify(userQueueIds)
		});
		return count;
	}

	const [attentionSummary, setAttentionSummary] = useState(null);
	const [closedTodayCount, setClosedTodayCount] = useState(null);

	useEffect(() => {
		const fetchAttentionSummary = async () => {
			try {
				const { data } = await api.get("/tickets/open-attention-summary", {
					params: { queueIds: JSON.stringify(userQueueIds) },
				});
				setAttentionSummary(data);
			} catch (err) {
				toastError(err);
			}
		};
		const fetchClosedToday = async () => {
			try {
				const { data } = await api.get("/tickets/closed-today-count", {
					params: { queueIds: JSON.stringify(userQueueIds) },
				});
				setClosedTodayCount(data.count);
			} catch (err) {
				toastError(err);
			}
		};
		fetchAttentionSummary();
		fetchClosedToday();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div>
			<Container maxWidth="lg" className={classes.container}>
				<Grid container spacing={3}>
					<Grid item xs={4}>
						<Paper className={classes.inAttendancePaper}>
							<Typography component="h3" variant="h6" color="primary" paragraph>
								{i18n.t("dashboard.messages.inAttendance.title")}
							</Typography>
							<Grid item>
								<Typography component="h1" variant="h4">
									{GetTickets("open", "true", "false")}
								</Typography>
							</Grid>
							{attentionSummary && (
								<div className={classes.attentionSummary}>
									<Typography
										className={`${classes.attentionSummaryLine} ${classes.needsAttentionLine}`}
									>
										{i18n.t("ticketsList.attentionRequired")}: {attentionSummary.needsAttention}
									</Typography>
									<Typography
										className={`${classes.attentionSummaryLine} ${classes.attendedLine}`}
									>
										{i18n.t("ticketsList.attended")}: {attentionSummary.attended}
									</Typography>
									<Typography
										className={`${classes.attentionSummaryLine} ${classes.postponedLine}`}
									>
										{i18n.t("dashboard.messages.inAttendance.postponed")}: {attentionSummary.postponed}
									</Typography>
								</div>
							)}
						</Paper>
					</Grid>
					<Grid item xs={4}>
						<Paper className={classes.customFixedHeightPaper} style={{ overflow: "hidden" }}>
							<Typography component="h3" variant="h6" color="primary" paragraph>
								{i18n.t("dashboard.messages.waiting.title")}
							</Typography>
							<Grid item>
								<Typography component="h1" variant="h4">
									{GetTickets("pending", "true", "false")}
								</Typography>
							</Grid>
						</Paper>
					</Grid>
					<Grid item xs={4}>
						<Paper className={classes.customFixedHeightPaper} style={{ overflow: "hidden" }}>
							<Typography component="h3" variant="h6" color="primary" paragraph>
								{i18n.t("dashboard.messages.closed.title")}
							</Typography>
							<Grid item>
								<Typography component="h1" variant="h4">
									{closedTodayCount ?? 0}
								</Typography>
							</Grid>
						</Paper>
					</Grid>
					<Grid item xs={12}>
						<Paper className={classes.fixedHeightPaper}>
							<Chart />
						</Paper>
					</Grid>
				</Grid>
			</Container>
		</div>
	)
}

export default Dashboard